import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, Stack, TextField, Typography } from "@mui/material"
import { PrincipalLayouts } from "../../../layouts"
import { Field } from "../miProfile/Field";
import { useForm } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { addCompany } from "../../helpers/company";
import { useSelector } from "react-redux";
import faradayApi from "../../../api/faradayApi";
import { countryList } from "../../../helpers/countryList";

export const AddCompany = () => {

    const { t } = useTranslation('global');
    const { role } = useSelector(state => state.auth)
    const navigate = useNavigate();
    const [partnerOptions, setPartnerOptions] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [isWaiting, setIsWaiting] = useState(false);
    const [formValues, handleInputChange, reset] = useForm({ partnerName: '', name: '', cif: '', address: '', zipCode: '', country: 'España', iban: '', swift: '' });

    const { partnerName, name, cif, address, zipCode, country, iban, swift } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        let dataForm = formValues;
        let url = '/companies'
        if (role === 'Admin') {
            const partnerSelected = partnerList.find(p => p.name === partnerName)
            dataForm = { ...formValues, individualId: partnerSelected.id }
            url = '/partners'
        }
        addCompany(dataForm, t('addcompany.succesMsg'), t('addcompany.errorMsg'), t('addcompany.dupCifMsg'), navigate, url)
        setIsWaiting(false)
        reset()
    }
    const handleCancel = () => {
        reset();
        role === 'Admin' ? navigate('/partners') : navigate('/companies')
    }

    useEffect(() => {
        const getListPartner = async () => {
            const { data } = await faradayApi.get('/user/getListNameAndId?type=Admin')
            setPartnerList(data.data)
            const nameList = data.data.map(e => e.name)
            setPartnerOptions(nameList)
            handleInputChange({ target: { "name": "partnerName", "value": nameList[0] } })
        }
        if (role === 'Admin') {
            getListPartner()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('addcompany.titlePage')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack width='100%' gap={2}>
                    {
                        role === 'Admin' &&
                        <Stack direction='column' width='100%' gap={0}>
                            <Typography variant='overline' color='secondary'>{t('addcompany.partner')}</Typography>
                            <Autocomplete
                                disablePortal
                                options={partnerOptions}
                                size='small'
                                renderInput={(params) => <TextField  {...params} variant='outlined' name='partnerName' />}
                                value={partnerName}
                                onSelect={handleInputChange}
                                fullWidth
                                required
                            />
                        </Stack>
                    }

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='companiestable' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                        <Field translation='companiestable' name={cif} title='cif' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    <Field translation='companiestable' name={address} title='address' handleInputChange={handleInputChange} />


                    <Stack width='100%' gap={2}>
                        <Typography variant='overline' color='secondary'>{t('companiestable.country')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={countryList}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='country' />}
                            value={country}
                            onSelect={handleInputChange}
                            required
                        />
                    </Stack>


                    <Stack >
                        <Field translation='companiestable' name={zipCode} title='zipCode' handleInputChange={handleInputChange} />
                    </Stack>

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='companiestable' name={iban} title='iban' handleInputChange={handleInputChange} />
                        <Field translation='companiestable' name={swift} title='swift' handleInputChange={handleInputChange} />
                    </Stack>

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}
